import React from "react";
import { cn } from "@/lib/utils";

const MAP = {
  draft: "bg-muted text-muted-foreground ring-border",
  confirmed: "bg-accent text-foreground ring-primary/20",
  in_progress: "bg-primary/10 text-primary ring-primary/25",
  completed: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 ring-emerald-500/25",
  shipped: "bg-sky-500/10 text-sky-600 dark:text-sky-400 ring-sky-500/25",
  blocked: "bg-destructive/10 text-destructive ring-destructive/25",
};

const LABELS = {
  draft: "Draft", confirmed: "Confirmed", in_progress: "In Progress",
  completed: "Completed", shipped: "Shipped",
};

export function StatusBadge({ status }) {
  const cls = MAP[status] || MAP.draft;
  const label = LABELS[status] || status;
  return (
    <span
      className={cn("inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset", cls)}
      data-testid={`status-badge-${status}`}
    >
      {label}
    </span>
  );
}
